import {
    CREATE_INVITATION,
    CREATE_INVITATION_FAILURE,
    CREATE_INVITATION_SUCCESS,
} from 'store/actions/types';

export const createInvitation = (payload) => {
    return {
        type: CREATE_INVITATION,
        payload: payload,
    };
};

export const createInvitationFailure = (error) => {
    return {
        type: CREATE_INVITATION_FAILURE,
        payload: error,
    };
};

export const createInvitationSuccess = (response) => {
    return {
        type: CREATE_INVITATION_SUCCESS,
        id: response.id,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/accounts/invitations/createInvitation.js